import React,{useState,useEffect} from 'react';
import { Modal, Box, Typography, Button,Card, useTheme ,Link,Snackbar,Alert} from '@mui/material';
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../common/hooks/useAuth';
import useRefreshToken from '../../../common/hooks/useRefreshToken';
import { SNACKBAR_AUTO_HIDE_DURATION_SHORT, SUBSCRIPTION_PLANS, TEXT_MSGS } from '../../../common/utility/constant';
import RupeeIcon from '@mui/icons-material/CurrencyRupee';
import OrderDetailPopup from './order_detail_popup';
import $ from 'jquery';
import { URL } from '../../../common/api/urls';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { bgcolor, borderRadius, display } from '@mui/system';
import bgImage from '../../../assets/images/Ecourse.png'
import bgImageBtn from '../../../assets/images/ECourse_btn_bg.png'


const style = {
    position: 'absolute',
    top: '7%',
    left: '10%',
    height: "90%",
    //   transform: 'translate(-50%, -50%)',
    width: "80%",
    bgcolor:"#163569",
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // display:"flex",
    boxShadow: 24,
    justifyContent:'center',
    alignItems:"center",
    p: 0,
    overflow: 'scroll',
  };
const cardEcourseSX={
 
    minWidth: "100%",maxWidth:"100%",minHeight:160, display:"flex", flexDirection:'column',alignItems:'center',marginTop:"20px",pl:1,pr:1,
    // backgroundColor:"#0CAFFF",
    backgroundColor:"#163569",
    // borderRadius:4 ,
    "&:hover": {
      // transition: "transform 0.15s ease-in-out",
      // transform: "scale3d(1.05, 1.05, 1)" 
    }
  }

const buttonSXPlusMedium= {
 
    width:250,mb:1,fontSize:22,height:54,background:"#EC6C10",backgroundColor:"#EC6C10",borderRadius:25,
    "&:hover": {
      backgroundColor:"#EC6C10",
      background:"#EC6C10",
      opacity:0.9
    },
  };


  

const EcoursePopup = ({ handleClose, onConfirm,ecourseAlreadyBought }) => {
    const from = "/login";
    const theme=useTheme();
    const navigate = useNavigate(); 
    const location = useLocation();
    const { auth } = useAuth();
    const refresh = useRefreshToken();
    const [planName,setPlanName]=useState(undefined);
    const [orderDetailsData,setOrderDetailsData]=useState();
    const [showorderPopup,setShowOrderPopup]=useState(false);
    const [isInternational,setIsInternational]=useState(false);
    const [amountDifference,setAmountDifference]=useState(0);
    const [cancelOrder,responseDataOrder,errorOrder,loadedOrder,resetOrder,executeAPIOrder] = useAxiosWithAuth();
 
    const [cancelOrderDetail,responseDataOrderDetail,errorOrderDetail,loadedOrderDetail,resetOrderDetail,executeAPIOrderDetail] = useAxiosWithAuth();
    const [msgState, setMsgState] = useState({
        open: false,
        msg:"" ,
        severity:"info"
      });
      const { open, msg, severity } = msgState;
  
    const handleClickEcourse = (event) => {
        console.log("handleClickEcourse=");
        let plan_name=SUBSCRIPTION_PLANS.VMR_ECOURSE;
        setPlanName(plan_name);
        const data={"plan_name": plan_name,"status_check":1}
        executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER,"POST",data)
      };
      const continuePayment=(code)=>{
        // console.log("COUPON CODE=",code);
        setShowOrderPopup(false);
        executeAPIOrder(URL.SUBSCRIPTION_ORDER,"POST",{"plan_name": planName,"status_check":0,"disc_coupon":code})
    }
          /**
   * API response handler subscription data
   */  
    useEffect(() => {
        console.log("OrderDetails=",responseDataOrderDetail);
        if(loadedOrderDetail){
          if(responseDataOrderDetail!=null){
            if(responseDataOrderDetail.success!=undefined && responseDataOrderDetail.success==true){
                console.log("OrderDetails 1=",responseDataOrderDetail);
             setOrderDetailsData(responseDataOrderDetail)
             setShowOrderPopup(true);
              
            }
            
            
          }
          else if(errorOrderDetail!==null){
            
            //if unauthorized then redirec it to login page
            if(errorOrderDetail?.response?.status === 401 || errorOrderDetail?.response?.status === 403){
              console.log("status received =",errorOrderDetail?.response?.status)
              navigate(from, { replace: true });
            //   setLoginMsg(errorOrderDetail?.response?.data?.message);
            //   setShowLoginPopup(true);
            }else 
            setMsgState({open:true,msg:errorOrderDetail?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
        }
        resetOrderDetail();
        }
      },[loadedOrderDetail,responseDataOrderDetail]);

       /**
   * API response handler subscription data
   */  
  useEffect(() => {
    if(loadedOrder){
      if(responseDataOrder!=null){
        if(responseDataOrder.success!=undefined && responseDataOrder.success==true){
          // const redirect_url=`https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&encRequest=${responseDataOrder.encRequest}&access_code=${responseDataOrder.access_code}`
          // window.link=redirect_url;
          // window.location=redirect_url;

          console.log(responseDataOrder);

          let url = 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
          if(responseDataOrder.type!=undefined && responseDataOrder.type=="test") url = 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
          let form = $('<form action="' + url + '" method="post">' +
                      '<input type="hidden" id="encRequest" name="dtype" value="'+ responseDataOrder.type+ '">'+
                      '<input type="hidden" id="encRequest" name="encRequest" value="'+ responseDataOrder.encRequest+ '">'+
                      '<input type="hidden" name="access_code" id="access_code" value="'+ responseDataOrder.access_code+ '">'+
                      '</form>');

          $('body').append(form);
          form.submit();
          
        }
        
        
      }
      else if(errorOrder!==null){
       
        //if unauthorized then redirec it to login page
        if(errorOrder?.response?.status === 401 || errorOrder?.response?.status === 403){
          console.log("status received =",errorOrder?.response?.status)
          // navigate(from, { replace: true });
        //   setLoginMsg(errorOrder?.response?.data?.message);
        //   setShowLoginPopup(true);
        }else
        setMsgState({open:true,msg:errorOrder?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
    }
    resetOrder();
    }
  },[loadedOrder,responseDataOrder]);

  return (
    <Modal
      open={true}
      onClose={handleClose}
      aria-labelledby="ecourse-popup-title"
      aria-describedby="ecourse-popup-description"
    >
      <Box sx={style}>
      <CancelOutlinedIcon
                onClick={() => handleClose()}
                sx={{
                ml: 0, mt: 0, top: `calc(7% - 12px)`,left: `calc(90% - 13px)`,
                height: 24, width: 26, cursor: 'pointer', position: 'fixed', zIndex: 9999
                }}
            />
        {/* <Typography id="ecourse-popup-title" variant="h6" component="h2" mb={2}>
          {title || 'E-Course Info'}
        </Typography> */}
        <Box sx={{ml:3,mt:0,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:"column",width:"100%",marginLeft:"0%",mb:2}}>
      <Card   sx={cardEcourseSX}>
        <Box sx={{display:'flex',flexDirection:"column",justifyContent:'flex-start',mb:1}}>

        <Typography sx={{mb:-2,mt:1,textAlign:'center',fontSize:"30px",fontWeight:700,color:"#FED994",lineHeight:1.1}}>Market Profile &<br />Orderflow Trading Strategies</Typography>
        <Typography sx={{mb:-2,mt:4,textAlign:'center',fontSize:"18px",fontWeight:500,color:"white",lineHeight:1}}>TRADE THE MARKET LIKE A PROFESSIONAL TRADER</Typography>
        <Typography sx={{mb:-2,mt:3,textAlign:'center',fontSize:"36px",fontWeight:500,color:"#FFC559",lineHeight:1.4}}>Subscribe now @ <RupeeIcon sx={{mb:-0.7,mt:0,mr:-1,textAlign:'center',fontSize:"34px",}}></RupeeIcon>4999 + 18% GST</Typography>
        {/* <Typography sx={{mb:0,mt:2,textAlign:'center',fontSize:"30px",fontWeight:700,color:"#FBE103"}}><Link href='https://vtrender.com/ecourse/' target='_blank' sx={{mb:0,textAlign:'center',fontSize:"30px",fontWeight:700,color:'#FBE103',cursor:"pointer"}} variant="link">ECourse</Link> Subscription</Typography> */}
            {/* <Typography sx={{mb:0,mt:0,textAlign:'center',fontSize:"40px",fontWeight:700,color:"#FBE103"}}><RupeeIcon sx={{mb:-0.5,mt:0,textAlign:'center',fontSize:"35px",fontWeight:700,color:"#FBE103"}}></RupeeIcon>5899</Typography> */}
            {/* <Typography sx={{mb:0.5,mt:-1,textAlign:'center',fontSize:"16px",fontWeight:600,color:"#FBE103"}}>Special Offer - Get FREE<sup>#</sup> 8 day access to Elite Index only plan which gives you Orderflow charts for Index instruments and Complete Options Suite access<br/>worth <RupeeIcon sx={{mb:-0.2,mt:0,textAlign:'center',fontSize:"14px",fontWeight:700,color:"#FBE103"}}></RupeeIcon>1000 + GST</Typography> */}
            {/* <Typography sx={{mb:0,mt:0,textAlign:'center',fontSize:"12px",fontWeight:500,color:"#fff"}}>(= 4999 + 900 GST)</Typography> */}
            {/* <Typography sx={{mb:2,mt:0,textAlign:'center',fontSize:"12px",fontWeight:500,color:"#fff"}}>one-time charges</Typography> */}
         {/* <Typography sx={{mb:2,mt:1,textAlign:'center',fontSize:"12px",fontWeight:500,color:"#fff"}}>Note: GST at 18% rate applicable on plan cost.</Typography> */}
              {/* <Button size="medium"  disabled={ecourseAlreadyBought} onClick={handleClickEcourse}  sx={buttonSXPlusMedium}><Typography sx={{color:'#51524F',fontWeight:600}}>{ecourseAlreadyBought?"Bought":"Buy Now*"}</Typography></Button> */}
             
      
        
      </Box>
     
      <Box
    sx={{
      width: 1050,
      height: 760,
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      borderRadius: 2,
      boxShadow: 0,
    }}
  >
   
   <Box
      sx={{
        // background: "linear-gradient(to right, #0D1B3D, #1A2E5C)",
        color: "white",
        textAlign: "center",
        py: 2,
        px: 2,
        marginTop:"360px"
      }}
    >
       {/* <Button size="medium"  disabled={ecourseAlreadyBought} onClick={handleClickEcourse}  sx={buttonSXPlusMedium}><Typography sx={{color:'#51524F',fontWeight:600}}>{ecourseAlreadyBought?"Bought":"Buy Now*"}</Typography></Button> */}
              
        {/* <Button
    variant="contained"
    disabled={ecourseAlreadyBought} onClick={handleClickEcourse} 
    sx={{
      width: 280,
      height: 66,
      backgroundImage: `url(${bgImageBtn})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: 'white',
      fontWeight: 'bold',
      fontSize: 16,
      borderRadius:10,
      '&:hover': {
        // backgroundSize: '110%', // zoom on hover 
      },
    }}
  >
  
  </Button> */}
  <Button
  disabled={ecourseAlreadyBought} onClick={handleClickEcourse} 
      sx={{
        // padding: '12px 12px',
        
        borderRadius: '999px',
        background: 'linear-gradient(to bottom, #fcd669, #f4b969)',
        boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
        textTransform: 'none',
        // display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '240px',
        height: 60,
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#000', lineHeight: 0.8,marginTop:"10px",ml:0.5 }}>
        E-Course*
      </Typography>
      <Typography variant="subtitle2" sx={{ color: '#524b4b' }}>
        Subscribe Now
      </Typography>
    </Button>

      <Typography variant="h4" fontWeight="bold"  sx={{ mt: 20.5,color:"#ed7926" }}>
        SPECIAL OFFER
      </Typography>

      <Typography fontWeight="bold" sx={{ fontSize:20, mt: 0.5,color:"#FED994",lineHeight:1.2 }}>
        {/* Get FREE<sup>#</sup> 8 day Access to <Box component="span" color="#FF5900">Elite Index</Box> only plan */}
        Get FREE<sup>#</sup> 8 day Access to Elite Index only plan
        <br/>
        It gives you access to Orderflow and Market Profile charts with Live data for all Index FnO instruments and Complete Options Suite worth more than <RupeeIcon sx={{mb:-0.3,mt:0,textAlign:'center',fontSize:"19px",}}></RupeeIcon>1000 + GST
      </Typography>

      {/* <Typography variant="h6" sx={{ mt: 1 }}>
        It gives you Orderflow charts for Index instruments and Complete Options Suite access worth <RupeeIcon sx={{mb:-0.2,mt:0,textAlign:'center',fontSize:"14px",fontWeight:700,color:"#FBE103"}}></RupeeIcon>1000 + GST
      </Typography> */}

      {/* <Typography variant="h6" sx={{ mt: 3 }} fontWeight="bold">
        # Instant Unlimited access
      </Typography>

      <Typography variant="caption" sx={{ mt: 2, display: "block" }}>
        * Please Check the ECourse Terms & Conditions
      </Typography> */}
      <Typography sx={{mb:1,mt:1,textAlign:'left',fontSize:"14px",fontWeight:500,color:"#fff"}}><sup>#</sup> Non upgradable trial plan</Typography>
    </Box>

  </Box>
    
               {/* <Typography sx={{mb:0,mt:1,textAlign:'center',fontSize:"12px",fontWeight:500,color:"#fff"}}>* Please Check the ECourse Terms & Conditions below</Typography> */}
              
           

      </Card>
          {/* <Typography id="modal-modal-description" sx={{ mt: 2, ml: 0 }}>
          For more details on this MarketProfile and Orderflow ECourse check the link: <Link href='https://vtrender.com/ecourse/' target='_blank' sx={{mb:1,textAlign:'center',fontSize:"17px",fontWeight:600,color:'#F3B23E',cursor:"pointer"}} variant="link">here</Link>
          </Typography> */}
          <Box sx={{px:4}}>
          <Typography id="modal-modal-description" sx={{ mt: 2, ml: 0,lineHeight:1.2 }}>
          <br/>
          <hr/>
         
          <Typography variant='h6'>*E-Course Terms & Conditions</Typography>
          <br/><b style={{color:"#F3B23E"}}>E-Course Activation:</b> The activation of ECourse is a manual step and though we try to do it ASAP, but please allow for a time of around 12-24 hours for the subscription to be activated.
          <br/><b style={{color:"#F3B23E"}}>One-Time Access:</b> The purchase grants the user a one-time access to the ECourse on Financial Markets & Trading Strategies.
          <br/><b style={{color:"#F3B23E"}}>No Recurring Fees:</b> The mentioned fee for the ECourse is a one-time charge. There will be no recurring charges or subscription fees after the initial payment.
          <br/><b style={{color:"#F3B23E"}}>ECourse Content:</b> The current plan offers access to 12 Expert-Led Online Video Tutorials. Any additional content, including but not limited to supplementary materials, handouts, or quizzes, is not guaranteed unless explicitly mentioned.
          <br/><b style={{color:"#F3B23E"}}>Future Courses Exclusion:</b> This purchase does not include access to any future courses, updates, or additions that may be made. Future courses or updates will need to be purchased separately.
          <br/><b style={{color:"#F3B23E"}}>No Refunds:</b> Once the purchase is made, no refunds are possible under any circumstances. Ensure you have read all the course details and terms before making the purchase.
          <br/><b style={{color:"#F3B23E"}}>Usage Limitation:</b> The purchased ECourse is for the individual use of the purchaser only. Sharing, distributing, or reproducing the content in any form is strictly prohibited and will result in immediate termination of access without any refunds.
          <br/><b style={{color:"#F3B23E"}}>Expert Guidance:</b> While our experts have vast experience and provide valuable insights, it's important to understand that trading and investment decisions should be made based on one's own judgment. We do not guarantee any specific financial outcomes or results from following our guidance.
          <br/><b style={{color:"#F3B23E"}}>Continuous Learning:</b> The derivatives markets and trading strategies evolve over time. It's important to keep updating your knowledge and not solely rely on the current content of this ECourse for long-term trading decisions.
          <br/><b style={{color:"#F3B23E"}}>Rate Changes:</b> The price for the ECourse, as mentioned, is subject to change without any prior notice. The rate at the time of purchase is final.
          <br/><b style={{color:"#F3B23E"}}>Complementary Benefits:</b> The Complementary 8-day Elite plan bundled with ECourse enables you to try out all chart features and it also gives you limited Orderflow charts access for Index Instruments only.
        </Typography>
        </Box>
      </Box>
      <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}} sx={{top:"48px"}} open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION_SHORT} >
          <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>  
       </Snackbar>
       {showorderPopup?
        <OrderDetailPopup data={orderDetailsData} planName={planName} onProceed={continuePayment} onCancel={()=>setShowOrderPopup(false)} isInternational={false} amountDifference={amountDifference}></OrderDetailPopup>
        :
        <></>
       }
         
      </Box>
      
    </Modal>
  );
};

export default EcoursePopup;